// @ts-nocheck
/* eslint-enable */
import React from 'react';
import {
  detailedInfoContainerCX,
  detailedInfoTextSkeletonCX,
  getHeroPhotoContainerCX,
  getListingCardContainerCX,
  priceSkeletonCX,
  skeletonWrapperCX,
} from './styles';

const ListingCardV3Skeleton = ({ displayName = '' }) => {
  return (
    <div className={skeletonWrapperCX} data-name="SkeletonWrapper">
      <article className={getListingCardContainerCX()} data-name="ListingCardContainer">
        <figure className={getHeroPhotoContainerCX(true)} data-name="HeroPhotoContainerSkeleton" />
        <section className={detailedInfoContainerCX} data-name="DetailedInfoContainer">
          <div className={priceSkeletonCX} data-name="PriceSkeleton" />
          <div className={detailedInfoTextSkeletonCX} data-name="DetailedInfoTextSkeleton" />
          {displayName ? (
            <h3>{displayName}</h3>
          ) : (
            <div className={detailedInfoTextSkeletonCX} data-name="DetailedInfoTextSkeleton" />
          )}
          <div className={detailedInfoTextSkeletonCX} data-name="DetailedInfoTextSkeleton" />
        </section>
      </article>
    </div>
  );
};

export default ListingCardV3Skeleton;
